export const formatPowerBookingItems = (bookingPeriods, selectedRate, showTotal = false) => {
    // Use powerBookingPriceBreakdown which has aggregated prices for multi-day bookings
    // Fall back to price_breakdown.items for backwards compatibility
    let priceBreakdownItems = [];
    if (selectedRate?.powerBookingPriceBreakdown?.length > 0) {
        // powerBookingPriceBreakdown uses V2 API format: { price: { value, currencyCode }, shortDescription, type }
        // Convert to V1 format: { price: number, short_description: string }
        priceBreakdownItems = selectedRate.powerBookingPriceBreakdown.map(item => ({
            price: item.price.value,
            short_description: item.shortDescription,
            full_description: item.fullDescription,
            type: item.type,
        }));
    }
    else {
        priceBreakdownItems = selectedRate?.price_breakdown?.items || [];
    }
    return priceBreakdownItems.map(item => {
        const bookingPeriodLength = bookingPeriods.length;
        const shortDescription = item.short_description === 'Subtotal'
            ? `${bookingPeriodLength} Day ${showTotal ? 'Total' : 'Subtotal'}`
            : item.short_description;
        let price = item.price;
        if (item.short_description === 'Subtotal') {
            // Calculate subtotal from rental items in powerBookingPriceBreakdown
            // to get the pre-discount subtotal
            if (selectedRate?.powerBookingPriceBreakdown) {
                const rentalItem = selectedRate.powerBookingPriceBreakdown.find(pbItem => pbItem.type === 'rental');
                price =
                    rentalItem?.price?.value || selectedRate?.subTotal?.value;
            }
            else {
                price = selectedRate?.subTotal?.value;
            }
        }
        if (item.short_description === 'Service Fee') {
            price = selectedRate.totalServiceFee;
        }
        return {
            ...item,
            short_description: shortDescription,
            price,
        };
    });
};
